<template>
  <div class="clipboard">
    <button @click="toggle" type="button" class="toggle_clipboard">
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18">
        <title>Icon / Desktop / Clipboard</title>
        <g fill="none" fill-rule="evenodd">
          <path stroke-linejoin="round" d="M9 2.5h4.5v15H.5v-15H5"/><path d="M9.5 3a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"/>
        </g>
      </svg>
      <b><i>Clipboard (</i>{{ count }} {{ label }}<i>)</i></b>
    </button>
    <clipboard-flyout
      v-show="active"
      :loading="loading"
      :records="clipboard"
      @refresh="refresh"
      @update-config-redirect-back="updateSourceRoute"
    />
  </div>
</template>

<script>
  import axios from 'axios';
  import ClipboardFlyout from './clipboard/ClipboardFlyout';

  export default {
    components: {
      ClipboardFlyout,
    },
    props: {
      disableRouteStore: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        active: false,
        loading: false,
        records: window.hasOwnProperty('clipboard') ? window.clipboard : [],
      }
    },
    watch: {
      //
    },
    computed: {
      count() {
        return this.clipboard ? this.clipboard.length : 0;
      },
      label() {
        return (this.count > 1 || this.count === 0) ? 'SKUs' : 'SKU';
      },
      clipboard() {
        if (this.records && this.records.length > 0) {
          return this.records.map((record) => {
            return {
              ... record,
              customizationsCount: record.selections ? Object.keys(record.selections).length : 0
            }
          })
        }
      },
    },
    methods: {
      close() {
        this.active = false;
      },
      toggle() {
        this.active = !this.active;
      },
      remove(record) {
        record.deleted = true;
      },
      refresh() {
        this.loading = true;

        axios.get('/configurator-module/api/clipboard/view')
        .then((response) => {
          this.records = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
      },
      updateSourceRoute(route) {
        if (this.disableRouteStore) {
          return;
        }
        localStorage.setItem("configRedirectBack", window.location.href);
      }
    },
    mounted() {
      // Retrieve data from the database to avoid caching.
      this.refresh();

      const escapeHandler = (e) => {
        if (e.key === 'Escape' && this.active) {
          this.close();
        }
      }

      const clickAwayHandler = (e) => {
        if (! this.$el.contains(e.target)) {
          this.close();
        }
      }

      document.addEventListener('click', clickAwayHandler);
      document.addEventListener('keydown', escapeHandler);

      this.$once('hook:destroyed', () => {
        document.removeEventListener('keydown', escapeHandler);
        document.removeEventListener('click', clickAwayHandler);
      });
    },
  }
</script>
